import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page54() {
  useEffect(() => {
    document.title = "Маяк — Страница 53"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page52" />
        <ForwardLink href="/page54" />
      </div>

      <p style={{ textAlign: "right" }}>53.</p>
      <p>— говорит он, пытаясь убедить себя.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        В 75-ом Старик Страйкер застрял<br/>
        здесь на долгие семь месяцев.<br/>
        На материке шторм утих, но<br/>
        здесь стояла такая волна,<br/>
        что нельзя было ни причалить, ни отчалить.
      </p>
      <p style={{ textAlign: "center" }}>
        МОЛОДОЙ<br/>
        Вы просто пытаетесь напугать меня.
      </p>
      <p>
        МОЛОДОЙ обеспокоен тем, что теряет рассудок. Или это СТАРИК<br/>
        его теряет?
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        Посмотри на себя. Притворяешься. Но ты прекрасно<br/>
        знаешь, что я прав.
      </p>
      <br/>
      <p>СНАРУЖИ. КАМЕННЫЙ ОСТРОВ. ПОЗАДИ ЖИЛЫХ ПОМЕЩЕНИЙ – НОЧЬ</p>
      <p>
        Шторм продолжается. СТАРИК держит две ЛОПАТЫ. Он бросает<br/>
        одну короткую в МОЛОДОГО.
      </p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        КОПАЙ.
      </p>
      <p>СТАРИК начинает копать как сумасшедший, на ветру и под дождем.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК (ПРОДОЛЖЕНИЕ)<br/>
        КОПАЙ, Я СКАЗАЛ!
      </p>
      <p>МОЛОДОЙ присоединяется, боясь того, что они могут откопать.</p>
      <br/>
      <p>– ПОЗЖЕ</p>
      <p>ОНИ вырыли глубокую, грязную яму. Размером примерно с МОГИЛУ.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        ВОТ ОН.
      </p>
      <p>СТАРИК откапывает...</p>
      <p>ДЕРЕВЯННЫЙ ЯЩИК.</p>
      <p>Он дает его МОЛОДОМУ.</p>
      <br/>
      <p>-НЕСКОЛЬКО МГНОВЕНИЙ СПУСТЯ</p>
      <p>Они открывают его...</p>
      <p style={{ textAlign: "right" }}>53.</p>

      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page52" />
        <ForwardLink href="/page54" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710630998/the-lighthouse-script/ayg9828yujwpuy3dhif2.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page54;
